import { createReducer, on } from "@ngrx/store";
import { LoadDemandeAchatList, LoadDemandeAchatListSuccess, LoadDemandeAchatListFail } from "./demande-achat-list.actions";

export interface LoadDemandeAchatListState {
	demandeAchatList: any;
	loading: boolean;
	error: string | null;
}

export const initialState: LoadDemandeAchatListState = {
	demandeAchatList: {},
	loading: false,
	error: null,
};

export const LoadDemandeAchatListReducer = createReducer(
	initialState,
	on(LoadDemandeAchatList, (state) => ({ ...state, loading: true, error: null })),
	on(LoadDemandeAchatListSuccess, (state, { demandeAchatList: demandeAchatList }) => ({
		...state,
		loading: false,
		demandeAchatList,
	})),
	on(LoadDemandeAchatListFail, (state, { error }) => ({
		...state,
		loading: false,
		error: error,
	}))
);
